import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import QuestionPage from './pages/NewsPlan/QuestionPage/QuestionPage';
import ConfirmationPage from './pages/NewsPlan/ConfirmationPage/ConfirmationPage';
import UploadDocumentsPage from './pages/NewsPlan/UploadDocumentsPage/UploadDocumentsPage';
import NewPersonalInformationPage from './pages/NewsPlan/NewPersonalInformationPage/NewPersonalInformationPage';

const Router = () => (
    <Routes>
        <Route path="" element={<NewPersonalInformationPage/>} />

        <Route path="newPersonalInformation" element={<NewPersonalInformationPage/>} />
        <Route path="newPersonalInformation/:getParametrs" element={<NewPersonalInformationPage/>} />
        <Route path="uploadDocuments" element={<UploadDocumentsPage/>} />
        <Route path="question" element={<QuestionPage/>} />
        <Route path="confirm" element={<ConfirmationPage/>} />

        <Route
            path="*"
            element={<Navigate to="/404" replace />}
        />
    </Routes>
);

Router.displayName = 'Router';

export default Router;
